import React, { useEffect, useState } from "react";
import CurrencyInput from "react-currency-input-field";
import Modal from "react-modal";
import { useParams } from "react-router";
import { useCartorio } from "../../../../../Hooks/cartorio";
import { useFuncionarioCartorio } from "../../../../../Hooks/funcionarioCartorio";
import { IBenfeitoria } from "../../../../../Pages/Cartorio_Pages/App_Pages/ImovelFocus";
import api from "../../../../../Services/api";
import { helpNumber } from "../../../../../Services/helpNumber";
import theme from "../../../../../Styles/theme";
import { isRural } from "../../../../../Utils/isRural";
import { Alert } from "../../../../Error/Alert";
import { ModalDivX } from "../../../../ModalDivX";
import { ModalLoader } from "../../../../ModalLoader";
import { Button, Container, ContainertInput, Input, Label } from "./styles";
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,
    minWidth: "40%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
  },
};

export type AreaTipo = 'M' | 'P';

interface Props {
  open: boolean;
  onClose(): void;
  benfeitoria: IBenfeitoria;
  handleSetBenfeitoria(ben: IBenfeitoria): void;
}

const limparNumeroComVirgula = (valor: string): string => {
  if (!valor) return '';

  // Remove tudo que não for dígito ou vírgula
  valor = valor.replace(/[^\d,]/g, '');

  // Divide em parte inteira e decimal
  const partes = valor.split(',');

  let inteiro = partes[0];
  const decimal = partes[1];

  // Remove zeros à esquerda
  inteiro = inteiro.replace(/^0+(?!$)/, '');

  // Adiciona o ponto de milhar na parte inteira
  inteiro = inteiro.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  // Se houver parte decimal, concatena com vírgula
  if (decimal !== undefined) {
    return `${inteiro},${decimal}`;
  }

  return inteiro;
};

export function FormBenfeitoriaModal({
  open,
  onClose,
  benfeitoria,
  handleSetBenfeitoria,
}: Props) {
  const { cartorioIsLogged, checarToken } = useCartorio();
  const {
    funcionarioCartorioIsLogged,
    checarTokenFuncionario,
  } = useFuncionarioCartorio();
  const { id } = useParams();
  const [TIPO, setTIPO] = useState("");
  const [AREA, setAREA] = useState("0");
  const [DESCRICAO, setDESCRICAO] = useState("");
  const [MATERIAL, setMaterial] = useState("");
  const [ANO, setANO] = useState(String(new Date().getFullYear()));
  const [AREA_TRANSMITIDA, setAREA_TRANSMITIDA] = useState("0");
  const [AREA_TIPO, setAREA_TIPO] = useState<AreaTipo>("M")


  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ message: "", title: "" });

  const labelCampo = AREA_TIPO.trim() === "M" ? "m²" : "%" ;

  async function post() {
    if (validaFormulario())
      try {
        setLoading(true);

        if (benfeitoria.ID) {
          const { data } = await api.put(`/benfeitorias`, {
            AREA: helpNumber(AREA),
            AREA_TRANSMITIDA: helpNumber(AREA_TRANSMITIDA),
            TIPO,
            DESCRICAO,
            ANO,
            IMOVEL_ID: id,
            MATERIAL,
            ID: benfeitoria.ID,
            AREA_TIPO,
          });


          handleSetBenfeitoria(data);
          onClose();
        } else {
          const { data } = await api.post(`/benfeitorias`, {
            AREA: helpNumber(AREA),
            AREA_TRANSMITIDA: helpNumber(AREA_TRANSMITIDA),
            TIPO,
            DESCRICAO,
            ANO,
            IMOVEL_ID: isRural() ? null : id,
            IMOVEL_RURAL_ID: isRural() ? id : null,
            MATERIAL,
            AREA_TIPO,
          });

          handleSetBenfeitoria(data);
          onClose();
        }
      } catch (error) {
        console.log(error);
        setError({
          title: "Ops",
          message: "Não foi possível salvar as alterações!",
        });
      } finally {
        setLoading(false);
      }
  }

  useEffect(() => {
    if (benfeitoria.ID) {
      console.log(benfeitoria);
      setTIPO(benfeitoria.TIPO);
      setAREA(new Intl.NumberFormat("pt-BR", { minimumFractionDigits: 0, maximumFractionDigits: 6 }).format(benfeitoria.AREA));
      setAREA_TRANSMITIDA(benfeitoria.AREA_TRANSMITIDA ? new Intl.NumberFormat("pt-BR", { minimumFractionDigits: 0, maximumFractionDigits: 6 }).format(benfeitoria.AREA_TRANSMITIDA) : "0");
      setDESCRICAO(benfeitoria.DESCRICAO);
      setMaterial(benfeitoria.MATERIAL);
      setANO(benfeitoria.ANO);
      setAREA_TIPO(benfeitoria.AREA_TIPO);
    } else {
      setTIPO("");
      setAREA("0");
      setAREA_TRANSMITIDA("0");
      setDESCRICAO("");
      setMaterial("");
      setANO(String(new Date().getFullYear()));
      setAREA_TIPO("M");
    }

  }, [open]);

  function validaFormulario() {
    if (TIPO.trim().length == 0) {
      setError({
        title: "Tipo não definido!",
        message: "É necessário definir o tipo da benfeitoria para adiciona-la!",
      });
      return false;
    }

    if (helpNumber(AREA) <= 0) {
      setError({
        title: "Área inválida!",
        message: "A área da benfeitoria não pode ser menor ou igual a zero!",
      });
      return false;
    }

    if (helpNumber(AREA_TRANSMITIDA) > helpNumber(AREA)) {
      setError({
        title: "Área Transmitida inválida!",
        message: "A área transmitida não pode ser maior que a área total da benfeitoria!",
      });
      return false;
    }

    if (DESCRICAO.trim().length <= 0) {
      setError({
        title: "Descrição não definida!",
        message:
          "É necessário definir uma descrição à benfeitoria para adiciona-la!",
      });
      return false;
    }

    if (MATERIAL.trim().length <= 0) {
      setError({
        title: "MATERIAL não definido!",
        message:
          "É necessário definir o material referente à benfeitoria para adiciona-la!",
      });
      return false;
    }

    if (Number(ANO) < 1900 || Number(ANO) > new Date().getFullYear() + 1) {
      setError({
        title: "Ano inválido!",
        message: "O ano de construção digitado é inválido!",
      });
      return false;
    }

    return true;
  }

  return (
    <Modal isOpen={open} onRequestClose={onClose} style={customStyles}>
      <ModalDivX execute={onClose} />
      <Container>
        <ContainertInput>
          <Label>
            TIPO
            <Input
              maxLength={50}
              placeholder="TIPO"
              value={TIPO}
              onChange={(ev) => setTIPO(ev.target.value)}
            />
          </Label>
        </ContainertInput>
        {isRural() && (
        <ContainertInput>
          <Label>
            UNIDADE DA ÁREA
            <div
              style={{
                display: "flex",
                gap: "1rem",
                marginTop: "0.5rem",
                alignItems: "center",
              }}
            >
              <label style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
                <input
                  type="radio"
                  value="M"
                  checked={AREA_TIPO.trim() === "M"}
                  onChange={() => setAREA_TIPO("M")}
                />
                Valores em m²
              </label>

              <label style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
                <input
                  type="radio"
                  value="P"
                  checked={AREA_TIPO.trim() === "P"}
                  onChange={() => setAREA_TIPO("P")}
                />
                Valores em %
              </label>
            </div>
          </Label>
        </ContainertInput>
        )}
        <ContainertInput>
          <Label>
            ÁREA {labelCampo}
            <Input
              style={{
                width: "100%",
                background: theme.colors.light,
                border: "none",
                color: theme.colors.dark,
                fontSize: "max(1vw, 10px)",
                padding: "1vh 2vw",
                borderRadius: "0.25rem",
              }}
              placeholder="ÁREA"
              value={AREA}
              onChange={(e) => setAREA(limparNumeroComVirgula(e.target.value))}
              inputMode="decimal"
            />

          </Label>
        </ContainertInput>
        <ContainertInput>
          <Label>
            Área Transmitida {labelCampo}
            <Input
              style={{
                width: "100%",
                background: theme.colors.light,
                border: "none",
                color: theme.colors.dark,
                fontSize: "max(1vw, 10px)",
                padding: "1vh 2vw",
                borderRadius: "0.25rem",
              }}
              placeholder="Área Transmitida"
              value={AREA_TRANSMITIDA}
              onChange={(e) => setAREA_TRANSMITIDA(limparNumeroComVirgula(e.target.value))}
              inputMode="decimal"
            />
          </Label>
        </ContainertInput>

        <ContainertInput>
          <Label>
            DESCRIÇÃO
            <Input
              maxLength={50}
              placeholder="DESCRIÇÃO"
              value={DESCRICAO}
              onChange={(ev) => setDESCRICAO(ev.target.value)}
            />
          </Label>
        </ContainertInput>

        <ContainertInput>
          <Label>
            MATERIAL
            <Input
              maxLength={50}
              placeholder="MATERIAL"
              value={MATERIAL}
              onChange={(ev) => setMaterial(ev.target.value)}
            />
          </Label>
        </ContainertInput>

        <ContainertInput>
          <Label>
            ANO
            <Input
              maxLength={4}
              placeholder="ANO"
              value={ANO}
              onChange={(ev) => setANO(ev.target.value.replace(/\D/g, ""))}
            />
          </Label>
        </ContainertInput>

        <Button onClick={post}>CONFIRMAR</Button>
      </Container>
      <ModalLoader loading={loading} />
      <Alert
        open={error.message.length > 0}
        onClose={() => setError({ message: "", title: "" })}
        message={error.message}
        title={error.title}
      />
    </Modal>
  );
}
